import "./LoginScreen.css"
import {useState} from "react";
import {useAuth} from "../../contexts/AuthContext";
import {ToastContainer, toast, Bounce} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
const LoginScreen = () => {
    const {login} = useAuth()
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    
    const handleLogin = () => {
        if(username === 'admin' && password === 'zaq1@WSX') {
            login({username, password});
        }
    }
    
    return (
        <div className={"loginScreen"}>
            <form onSubmit={handleLogin} className={"loginForm"}>
                <div className={"row"}>
                    <label htmlFor="username">Nazwa użykownika:</label>
                    <input
                        className={"input"}
                        id="username"
                        type="text"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                    />
                </div>
                <div className={"row"}>
                    <label htmlFor="password">Hasło:</label>
                    <input
                        id="password"
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                </div>
                <button type="submit">Login</button>
            </form>
        </div>
    )
}

export default LoginScreen;